import React from 'react';
import { Box, Typography } from '@mui/material';
import 'cssComponents/Loader.css';

const Loader = () => {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                background: 'linear-gradient(to bottom, #001f3f, #0074D9)',
                zIndex: 1500
            }}
        >
            <div className="custom-circle" />
            <Typography variant="h4" className="trucred-text">
                <span className="flicker">T</span> <span className="flicker">R</span> <span className="flicker">U</span>{' '}
                <span className="flicker">C</span> <span className="flicker">R</span> <span className="flicker">E</span>{' '}
                <span className="flicker">D</span>
            </Typography>
        </Box>
    );
};

export default Loader;
